import { LOCKUP, MARK_HEIGHT, MARK_NAVY, MARK_SAND, MARK_WIDTH, WORDMARK } from "@bres/ui/brand";

/** Beeldmerk van BRES (navy en zand). Kleuren via CSS: --brand-mark-navy en --brand-mark-sand, zodat het ook op navy werkt. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={`brand-mark${className ? ` ${className}` : ""}`} viewBox={`0 0 ${MARK_WIDTH} ${MARK_HEIGHT}`} aria-hidden focusable="false">
      <path className="brand-mark__navy" d={MARK_NAVY} />
      <path className="brand-mark__sand" d={MARK_SAND} />
    </svg>
  );
}

/** Horizontale lockup: beeldmerk met het woordmerk BRES. */
export function BrandLockup({ className, label = "BRES" }: { className?: string; label?: string }) {
  return (
    <svg className={`brand-lockup${className ? ` ${className}` : ""}`} viewBox={`0 0 ${LOCKUP.width} ${LOCKUP.height}`} role="img" aria-label={label}>
      <path className="brand-mark__navy" d={MARK_NAVY} />
      <path className="brand-mark__sand" d={MARK_SAND} />
      <path className="brand-lockup__word" transform={`translate(${LOCKUP.wordX} ${LOCKUP.wordY}) scale(${LOCKUP.wordScale})`} d={WORDMARK} />
    </svg>
  );
}
